module.exports = __webpack_public_path__ + "static/media/store.4c02bb9a.svg";